import PropTypes from 'prop-types';
import React from 'react';

import tablerSprite from './tablerSprite.svg';

const TablerIcon = ({ name, size, color, className, ...props }) => {
  const removeInvalidProps = { ...props };
  delete removeInvalidProps.isOpen;

  const calculateStrokeWidth = size => (size > 32 ? 2 : 1);

  return (
    <div
      className={`flex justify-center ${className}`}
      style={{ minWidth: `${size}px`, minHeight: `${size}px` }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`icon-tabler-${name}`}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        strokeWidth={calculateStrokeWidth(size)}
        stroke={color}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...removeInvalidProps}
      >
        <use xlinkHref={`${tablerSprite}#tabler-${name}`} />
      </svg>
    </div>
  );
};

TablerIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

TablerIcon.defaultProps = {
  size: 24,
  color: '#344054',
  className: '',
};

export default TablerIcon;
